// Refresh Smart Group
export const REFRESH_SMART_GROUP_REQUEST = 'REFRESH_SMART_GROUP_REQUEST';
export const REFRESH_SMART_GROUP_DONE = 'REFRESH_SMART_GROUP_DONE';
export const REFRESH_SMART_GROUP_FAILED = 'REFRESH_SMART_GROUP_FAILED';
export const REFRESH_SMART_GROUP_RESET = 'REFRESH_SMART_GROUP_RESET';